import React, { useEffect, useState, useRef } from "react";
import bgvideo from "../../images/bgvideo.mp4";
import logo from "../../images/logo.png";
import facebook from "../../images/facebook.svg";
import google from "../../images/google.svg";
import twitterfill from "../../images/twitter-fill.svg";
import { Link } from "react-router-dom";
import { callApi } from "../common/API/Api";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { negate } from "lodash";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { handleToggleCollapse, useModal } from "../common/Collapsfunction";
import { getBaseUrl } from "../common/BaseUrl";
const Login = () => {
    const { modalRefs, openModal } = useModal();
  document.title = "Equlix";
   let base_url = getBaseUrl();
  let base_api_url = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();
  const twitterlogin = async () => {
    try {
      let url = `${base_api_url}auth/twitter`;
      window.location.href = url;
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    // Load the Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "9178007688902901", // Replace with your Facebook App ID
        cookie: true,
        xfbml: true,
        version: "v18.0", // Use a valid Facebook API version
      });
    };

    // Load the SDK script dynamically
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const handleFacebookLogin = () => {
    if (!window.FB) {
      console.error("Facebook SDK not loaded yet.");
      return;
    }

    window.FB.login(
      function (response) {
        if (response.authResponse) {
          fetchFacebookData(response.authResponse.accessToken);
        }
      },
      { scope: "public_profile,email" },
    );
  };

  const fetchFacebookData = async (accessToken) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/auth/facebook/callback?token=${accessToken}`,
        "GET",
      );
      if (res?.data?.success) {
        localStorage.setItem("token", res?.data?.token);
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || "Login failed",
        }));
        localStorage.setItem("token", "");
      }
    } catch (err) {
      console.log(err, "Error during API call");
    }
  };
  const googleLoginRef = useRef(null);
  const handleLoginSuccess = async (response) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/auth/google/callback?token=${response?.credential}`,
        "GET",
      );
      if (res?.data?.success) {
        localStorage.setItem("token", res?.data?.token);
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || "Login failed",
        }));
        localStorage.setItem("token", "");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const handleLoginFailure = (error) => {
    console.log("Login Failed:", error);
  };

  const handleImageClick = () => {
    // Trigger the Google login when the image is clicked
    googleLoginRef.current?.signIn();
  };
  const [hover, setHover] = useState(false);
  // let base_url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
  const [showpassword, setShowpassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logindata, setLogindata] = useState();
  const navigate = useNavigate();
  const [validmessage, setvalidmessage] = useState({
    email: "",
    password: "",
    error: "",
  });
  const setuplogindata = (key, value) => {
    setLogindata((state) => ({
      ...state,
      [key]: value,
    }));
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        loginvalidaction(logindata); // Your function
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown); // Clean up
    };
  }, [logindata]);
  const loginvalidaction = (logindata) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!logindata?.email) {
      setvalidmessage((state) => ({
        ...state,
        email: t("Email is Required"),
        error: "",
      }));
      return;
    } else if (!emailRegex.test(logindata?.email)) {
      setvalidmessage((state) => ({
        ...state,
        email: t("Please enter a valid email address."),
        error: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        email: "",
      }));
    }
    if (!logindata?.password) {
      setvalidmessage((state) => ({
        ...state,
        password: t("password is Required"),
        error: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        password: "",
      }));
    }
    login(logindata);
  };

  const login = async (logindata) => {
    try {
      setLoading(true);
      localStorage.setItem("token", "");
      const formData = new FormData();
      for (let key in logindata) {
        if (logindata.hasOwnProperty(key)) {
          formData.append(key, logindata[key]);
        }
      }
      let postdata = formData;
      let res = await callApi(postdata, `api/login`, "POST");
      if (res?.data?.success) {
        if (res?.data?.data?.deleted_by === 1) {
          const apiMessage = res?.data?.data?.close_reason;
          setvalidmessage((state) => ({
            ...state,
            error: apiMessage,
            delete: true,
          }));
          return;
        }
        localStorage.setItem("token", res?.data?.token);
        if (res?.data?.data?.deleted_at && res?.data?.data?.deleted_by === 0) {
          navigate(`${base_url}closeaccount`, {
            state: { from: res?.data?.data },
          });
        } else {
          navigate(`${base_url}userdashboard`, {
            state: { from: "real_account" },
          });
        }
      
      } else {
        const apiMessage = res?.data?.message;

        const isSqlError =
          apiMessage?.toLowerCase().includes("sql") ||
          apiMessage?.toLowerCase().includes("syntax") ||
          apiMessage?.toLowerCase().includes("query") ||
          apiMessage?.toLowerCase().includes("exception");

        setvalidmessage((state) => ({
          ...state,
          error: isSqlError
            ? t("Login failed")
            : apiMessage || t("Login failed"),
          delete: res?.data?.delete,
        }));
        localStorage.setItem("token", "");
        if (res?.data?.html) {
          navigate(`${base_url}blockpage`, {
            state: { myData: res?.data?.message },
          });
        }
      }
    } catch (err) {
      console.error("Error during login:", err);
    } finally {
      setLoading(false);
    }
  };
  const videoRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const handleVideoEnd = () => {
    // Begin the black screen transition effect
    setIsTransitioning(true);
    // Delay to show the black screen for 1 second, then restart video smoothly
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0; // Reset to the start
        videoRef.current.play(); // Start playing from the beginning
      }
      setIsTransitioning(false); // Remove black screen transition
    }, 100); // Show black screen for 1 second
  };

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      // Listen for the video's `timeupdate` to detect nearing end
      const handleTimeUpdate = () => {
        if (video.duration - video.currentTime <= 1) {
          setIsTransitioning(true); // Start fading out near the end
        }
      };

      video.addEventListener("timeupdate", handleTimeUpdate);
      video.addEventListener("ended", handleVideoEnd); // Trigger on end

      // Automatically play the video on component load
      video.play();

      return () => {
        video.removeEventListener("timeupdate", handleTimeUpdate);
        video.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, []);
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const token = params.get("state");
  //   console.log(token, "token");
  //   if (token) {
  //     navigate("/dashboard");
  //   } else {

  //   }
  // }, [navigate]);
  useEffect(() => {
    if (token) {
      navigate(`${base_url}userdashboard`, {
        state: { from: "real_account" },
      });
    }
  }, [token]);

  useEffect(() => {
    // Load the Google script dynamically
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Once the script loads, initialize the Google Sign-In
    script.onload = () => {
      /* global google */
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id:
            "1097535902152-f8agb9eee4shcjt8td1rtn6rtpel3lpk.apps.googleusercontent.com",
          callback: handleCredentialResponse,
          auto_select: false,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("googleSignInDiv"),
          {
            theme: "outline",
            size: "large",
            text: "signin_with",
            shape: "rectangular",
            logo_alignment: "left",
          },
        );
      }
    };
  }, []);

  const handleCredentialResponse = async (response) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/auth/google/callback?token=${response?.credential}`,
        "GET",
      );
      if (res?.data?.success) {
        localStorage.setItem("token", res?.data?.token);
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || "Login failed",
        }));
        localStorage.setItem("token", "");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  return (
    <div className="theme-color-1">
      <div className="mainLoginbg">
        <div style={{ position: "relative", overflow: "hidden" }}>
          {/* Video element */}
          <video
            ref={videoRef}
            playsInline
            loop={false} // Set loop to false to control replay manually
            muted
            autoPlay
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: !isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out",
            }}
          >
            <source src={bgvideo} type="video/mp4" />
          </video>

          {/* Black screen overlay for transition */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "black",
              opacity: isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out", // Smooth transition for fade effect
              pointerEvents: "none", // Allow clicks to pass through
            }}
          />
        </div>
        {/* <video playsInline loop muted autoPlay>
          <source src={bgvideo} type="video/mp4" />
        </video> */}
        {/* <video playsinline="" loop="" muted="" autoplay="">
            <source src="images/bgvideo.mp4" type="video/mp4"/>
         </video> */}

        <section className="loginRegisterform maxwidth">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-md-8">
                <div className="public-header">
                  <div className="site_logo">
                    <Link to={`${base_url}`}>
                      <img src={logo} alt="" />
                    </Link>
                  </div>
                  <LanguageSwitcher />
                </div>

                <form action="#">
                  <div className="form-title">
                    <h4>{t("Log in")}</h4>
                  </div>
                  <div className="form-group">
                    <input
                      onChange={(e) => setuplogindata("email", e.target.value)}
                      type="email"
                      className={
                        validmessage?.email
                          ? "form-control border-danger"
                          : "form-control"
                      }
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder={t("Email address")}
                    />
                    {validmessage?.email ? (
                      <p className="p-0 text-danger">{validmessage?.email}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      onChange={(e) =>
                        setuplogindata("password", e.target.value)
                      }
                      type={showpassword ? "text" : "password"}
                      id="password"
                      className={
                        validmessage?.password
                          ? "form-control border-danger"
                          : "form-control"
                      }
                      placeholder={t("Password")}
                    />
                    <i
                      onClick={() => setShowpassword(!showpassword)}
                      className={`toggle-password fa-regular fa-fw ${
                        showpassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                    ></i>
                    {/* <i className="fa-regular fa-eye"></i>  */}
                    {validmessage?.password ? (
                      <p className="p-0 text-danger">
                        {validmessage?.password}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-forgot-password">
                    <Link
                      to={`${base_url}forgotpassword`}
                      style={{
                        color: hover ? "var(--bs-link-hover-color)" : "",
                      }}
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                    >
                      {t("Forgot Password")}?
                    </Link>
                  </div>
                  {validmessage?.error ? (
                    validmessage?.delete ? (
                      <div class="alertBox">
                        <div class="alert alert-danger">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="rgba(240,187,64,1)"
                          >
                            <path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"></path>
                          </svg>
                          <ul>
                            <li>
                              Your account has been closed. <br />
                              <b>{validmessage?.error}</b>
                            </li>
                            <li>
                              For further assistance, please contact us at{" "}
                              <a
                                href="mailto:support@equlix.com"
                                style={{
                                  color: "#007bff",
                                  textDecoration: "underline",
                                }}
                              >
                                support@equlix.com
                              </a>
                              .
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <p className="p-0 text-danger">{validmessage?.error}</p>
                    )
                  ) : (
                    ""
                  )}

                  {loading ? (
                    <button type="button" className="btn bg_btn">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>{" "}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn bg_btn"
                      onClick={() => loginvalidaction(logindata)}
                      style={{ fontSize: "17px" }}
                    >
                      {t("Log In")}
                    </button>
                  )}
                  <p>
                    {t("Don't have an account?")}{" "}
                    <Link to={`${base_url}signup`}>{t("Sign up")}</Link>
                  </p>
                  <div className="borderline"></div>
                  <div className="or">{t("Or")}</div>

                  <div className="social_icon">
                    {/* <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        handleFacebookLogin();
                      }}
                    >
                      <img src={facebook} alt="" /> {t("Facebook")}
                    </Link> */}
                    {/* <h2>Google Login Demo</h2> */}
                    {/* <div className="social_logins0"
                        // onClick={handleImageClick} // Trigger login on image click
                          style={{ cursor: "pointer" }} >
                      <img
                        src={google}
                        alt="Google Login"
                       // Optional, to show a pointer on hover
                      />
                      {t("Google")}
                        <div className="googleClick">
                        <div
                        ref={googleLoginRef}
                        id="googleSignInDiv"
                        // style={{ display: "none" }}
                      ></div>
                        </div>
                    
                    </div> */}
                    <div
                      className="social_logins0"
                      onClick={handleImageClick} // Trigger login on image click
                      style={{ cursor: "pointer" }}
                    >
                      <GoogleOAuthProvider clientId="1097535902152-f8agb9eee4shcjt8td1rtn6rtpel3lpk.apps.googleusercontent.com">
                        <img src={google} alt="" /> {t("Google")}
                        <div className="googleClick">
                          <GoogleLogin
                            ref={googleLoginRef} // Assign ref to GoogleLogin
                            onSuccess={handleLoginSuccess}
                            onError={handleLoginFailure}
                            style={{ display: "none" }} // Hide the default button
                          />
                        </div>
                      </GoogleOAuthProvider>
                    </div>
                    {/* <GoogleOAuthProvider clientId="1097535902152-f8agb9eee4shcjt8td1rtn6rtpel3lpk.apps.googleusercontent.com">
                      <GoogleLogin
                          ref={googleLoginRef} // Assign ref to GoogleLogin
                          onSuccess={handleLoginSuccess}
                          onError={handleLoginFailure}
                          // style={{ display: "none" }} // Hide the default button
                        />
                     </GoogleOAuthProvider> */}

                    {/* <Link to="" onClick={(e) => e.preventDefault()}>
                      <GoogleOAuthProvider clientId="1097535902152-f8agb9eee4shcjt8td1rtn6rtpel3lpk.apps.googleusercontent.com">
                        <img
                          src={google}
                          alt="Google Login"
                          onClick={handleImageClick} // Trigger login on image click
                          style={{ cursor: "pointer" }} // Optional, to show a pointer on hover
                        />
                        {t("Google")}
                        <GoogleLogin
                          ref={googleLoginRef} // Assign ref to GoogleLogin
                          onSuccess={handleLoginSuccess}
                          onError={handleLoginFailure}
                          // style={{ display: "none" }} // Hide the default button
                        />
                      </GoogleOAuthProvider>
                    </Link> */}
                    {/* <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        twitterlogin();
                      }}
                    >
                      <img src={twitterfill} alt="" /> {t("Twitter")}
                    </Link> */}
                    {/* <a href="javascript:;"><img src="images/app.svg"></a>  */}
                  </div>
                </form>
              </div>
              {/* <div className="col-xl-6 col-md-6">
                     <div className="loginCard">
                        <img src="images/login-bg.png">
                        <div className="shorttext">
                           <h4>Secure and Simple Access</h4>
                           <p>Log in to your Equlix account securely. Access your trading dashboard and manage your portfolio with ease. Your data is protected by top-notch security measures.</p>
                        </div>
                     </div>
                  </div>  */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
